import { render, staticRenderFns } from "./PostCountBar.vue?vue&type=template&id=843e0548"
import script from "./PostCountBar.vue?vue&type=script&lang=js"
export * from "./PostCountBar.vue?vue&type=script&lang=js"
import style0 from "./PostCountBar.vue?vue&type=style&index=0&id=843e0548&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports